import { ISetPaymentRequestStatus, setPaymentRequestStatus } from '../api/withdraw';

import { useMutation, UseMutationResult } from 'react-query';
import { QueryKeys } from '../constants';

import { TVoidAxios } from '../types/TVoidAxios';
import { AxiosError } from 'axios';

export function usePaymentRequestStatus(): UseMutationResult<TVoidAxios, AxiosError, ISetPaymentRequestStatus> {
    return useMutation([QueryKeys.setPaymentRequestStatus], (params: ISetPaymentRequestStatus) =>
        setPaymentRequestStatus(params)
    );
}
